var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGlucroft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glucroft_Logo",
    "data-name": "Glucroft Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175,
    height: 39.487,
    viewBox: "0 0 175 39.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003b70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004d87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7c7f82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004d87"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15923",
    "data-name": "Group 15923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15922",
    "data-name": "Group 15922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15918",
    "data-name": "Group 15918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10403",
    "data-name": "Path 10403",
    d: "M21,14.178a5.409,5.409,0,0,0-.53,2.12v4.415a13.784,13.784,0,0,1-6.285,1.337,10.272,10.272,0,0,1-6.916-2.4,7.918,7.918,0,0,1-2.9-6.309A8.654,8.654,0,0,1,7.121,7.009a9.671,9.671,0,0,1,7.041-2.852,11.788,11.788,0,0,1,5.88,1.566L20.268,8.5a8.448,8.448,0,0,0-6.106-2.9,6.023,6.023,0,0,0-5.3,2.65A7.463,7.463,0,0,0,7.576,12.99a8.489,8.489,0,0,0,2.373,5.6,5.9,5.9,0,0,0,4.442,2.1,7.411,7.411,0,0,0,3.129-.631V16.3a5.409,5.409,0,0,0-.53-2.12H21Z",
    fill: "#004d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10404",
    "data-name": "Path 10404",
    d: "M34.454,19.781l-.706,2.1h-10.5A7.013,7.013,0,0,0,23.778,19V7.086a7.013,7.013,0,0,0-.53-2.876h4.013a7.013,7.013,0,0,0-.53,2.876V20.665h4.745a10.389,10.389,0,0,0,2.977-.884Z",
    fill: "#004d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10405",
    "data-name": "Path 10405",
    d: "M50.2,4.234A4.825,4.825,0,0,0,49.876,6.1v8.958a6.9,6.9,0,0,1-2.146,5.1,7.092,7.092,0,0,1-5.174,2.12,7.7,7.7,0,0,1-5.377-2.157,6.781,6.781,0,0,1-2.322-5.137v-7.9a6.947,6.947,0,0,0-.53-2.852h4.013a6.947,6.947,0,0,0-.53,2.852v7.9A5.852,5.852,0,0,0,39.3,18.961a4.657,4.657,0,0,0,3.635,1.7,5.508,5.508,0,0,0,4.013-1.64,5.362,5.362,0,0,0,1.667-3.963V6.1a4.816,4.816,0,0,0-.328-1.867H50.2Z",
    fill: "#004d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10406",
    "data-name": "Path 10406",
    d: "M68.146,19.6a10.2,10.2,0,0,1-6.511,2.447A10.066,10.066,0,0,1,54.8,19.728a8.032,8.032,0,0,1-2.977-6.41A8.618,8.618,0,0,1,54.57,7.009a9.671,9.671,0,0,1,7.041-2.852,11.788,11.788,0,0,1,5.88,1.566L67.718,8.5a8.448,8.448,0,0,0-6.106-2.9,5.983,5.983,0,0,0-5.3,2.65,7.111,7.111,0,0,0-1.286,4.745,8.851,8.851,0,0,0,2.4,5.654,5.942,5.942,0,0,0,4.418,2.045,7.871,7.871,0,0,0,5.829-2.676l.479,1.59Z",
    fill: "#004d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10407",
    "data-name": "Path 10407",
    d: "M85.712,21.9H81.145q-2.169-2.145-3.331-3.483a45.176,45.176,0,0,1-4.088-5.627l.506-.253a5.49,5.49,0,0,0,1.236.152,3.2,3.2,0,0,0,2.676-1.19A3.055,3.055,0,0,0,78.8,9.118a4.178,4.178,0,0,0-.959-2.431Q76.5,5.321,73.3,5.446V19.014a7.181,7.181,0,0,0,.53,2.887H69.814a7.146,7.146,0,0,0,.53-2.881V7.065a7.031,7.031,0,0,0-.53-2.881H73.55a16.718,16.718,0,0,1,4.948.53,4.511,4.511,0,0,1,3.307,4.367,3.822,3.822,0,0,1-1.566,3.433,6.246,6.246,0,0,1-3.281,1.236,35.194,35.194,0,0,0,3.18,3.686q1.59,1.49,5.576,4.466Z",
    fill: "#004d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10408",
    "data-name": "Path 10408",
    d: "M119.519,6.2a10.032,10.032,0,0,0-3.129-.732h-4.367V11.7h6.612l-.429,1.262h-6.184v6.04a6.974,6.974,0,0,0,.53,2.868h-4.013a7.013,7.013,0,0,0,.53-2.876V7.086a7.013,7.013,0,0,0-.53-2.876h10.1l.884,1.995Z",
    fill: "#004d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10409",
    "data-name": "Path 10409",
    d: "M136.6,6.2a10.032,10.032,0,0,0-3.129-.732h-3.584V19a7.013,7.013,0,0,0,.53,2.876h-3.987a7.013,7.013,0,0,0,.53-2.876V5.47h-3.584a10.016,10.016,0,0,0-3.129.732l.884-1.995H135.72L136.6,6.2Z",
    fill: "#004d87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15919",
    "data-name": "Group 15919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10410",
    "data-name": "Path 10410",
    d: "M35.535,39.106H32.657a5.055,5.055,0,0,0,.381-2.064V28.494a5.047,5.047,0,0,0-.381-2.064h2.879a5.055,5.055,0,0,0-.381,2.064v8.548A5.047,5.047,0,0,0,35.535,39.106Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10411",
    "data-name": "Path 10411",
    d: "M48.576,26.428a3.538,3.538,0,0,0-.234,1.339v11.72H47.78l-9.038-9.872v8.17a3.538,3.538,0,0,0,.234,1.339H37.6a3.538,3.538,0,0,0,.234-1.339v-11.7h.525l9.076,9.853v-8.17a3.591,3.591,0,0,0-.234-1.339Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10412",
    "data-name": "Path 10412",
    d: "M61.6,26.446a8.7,8.7,0,0,0-1.105,1.9L55.878,39.306h-.506L50.826,28.638a4.919,4.919,0,0,0-.615-1.124c-.048-.061-.357-.415-.924-1.068H52.2l4.058,9.491,4.021-9.491h1.324Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10413",
    "data-name": "Path 10413",
    d: "M69.55,39.106H62.016a5.055,5.055,0,0,0,.381-2.064V28.494a5.047,5.047,0,0,0-.381-2.064h7.246l.634,1.43a7.221,7.221,0,0,0-2.245-.525H64.517v3.931h4.527l-.309.905H64.514v6.069H67.92a7.428,7.428,0,0,0,2.264-.543l-.634,1.414Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10414",
    "data-name": "Path 10414",
    d: "M80.564,35.541a3.259,3.259,0,0,1-2.173,3.134,5.791,5.791,0,0,1-2.9.6,11.708,11.708,0,0,1-1.358-.144,9.427,9.427,0,0,1-2.916-1.2l-.272-2.064a12.59,12.59,0,0,0,1.43,1.268,5.94,5.94,0,0,0,3.169,1.339,2.9,2.9,0,0,0,1.686-.453,2.12,2.12,0,0,0,1.033-1.467,2.839,2.839,0,0,0,.053-.543,1.934,1.934,0,0,0-.652-1.449,9.879,9.879,0,0,0-2.154-1.377,21.936,21.936,0,0,1-2.863-1.648,2.764,2.764,0,0,1-1.286-2.192,2.271,2.271,0,0,1,.037-.415,2.72,2.72,0,0,1,1.286-1.776,5.411,5.411,0,0,1,3.025-.905,8.572,8.572,0,0,1,3.912.977l.2,1.686a5.706,5.706,0,0,0-3.859-1.867,2.892,2.892,0,0,0-.471.037q-1.849.364-1.848,1.611,0,1.322,2.644,2.591a15.84,15.84,0,0,1,3.025,1.758,3.2,3.2,0,0,1,1.249,2.5Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10415",
    "data-name": "Path 10415",
    d: "M91.956,27.86a7.221,7.221,0,0,0-2.245-.525H87.139v9.709a5.047,5.047,0,0,0,.381,2.064H84.657a5.055,5.055,0,0,0,.381-2.064V27.336H82.466a7.189,7.189,0,0,0-2.245.525l.634-1.43H91.323Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10416",
    "data-name": "Path 10416",
    d: "M110.909,33.583a3.906,3.906,0,0,0-.381,1.521v3.169a9.913,9.913,0,0,1-4.511.959,7.37,7.37,0,0,1-4.964-1.72,5.686,5.686,0,0,1-2.082-4.527,6.212,6.212,0,0,1,1.973-4.546A6.947,6.947,0,0,1,106,26.39a8.472,8.472,0,0,1,4.221,1.124l.162,1.992A6.065,6.065,0,0,0,106,27.424a4.318,4.318,0,0,0-3.8,1.9,5.365,5.365,0,0,0-.924,3.406,6.109,6.109,0,0,0,1.7,4.021,4.231,4.231,0,0,0,3.188,1.5,5.3,5.3,0,0,0,2.245-.453v-2.7a3.9,3.9,0,0,0-.381-1.521H110.9Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10417",
    "data-name": "Path 10417",
    d: "M123.391,39.125h-2.916L118.5,34.489h-4.149L112.4,39.125h-1.324a8.7,8.7,0,0,0,1.105-1.9l4.618-10.958h.509l4.546,10.668a4.819,4.819,0,0,0,.615,1.124c.048.061.357.415.924,1.068Zm-5.361-5.707-1.611-3.787-1.6,3.787h3.206Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10418",
    "data-name": "Path 10418",
    d: "M132.184,27.86a7.221,7.221,0,0,0-2.245-.525h-2.572v9.709a5.047,5.047,0,0,0,.381,2.064h-2.863a5.055,5.055,0,0,0,.381-2.064V27.336h-2.572a7.189,7.189,0,0,0-2.245.525l.634-1.43H131.55Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10419",
    "data-name": "Path 10419",
    d: "M135.824,39.106h-2.879a5.055,5.055,0,0,0,.381-2.064V28.494a5.047,5.047,0,0,0-.381-2.064h2.879a5.055,5.055,0,0,0-.381,2.064v8.548A5.046,5.046,0,0,0,135.824,39.106Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10420",
    "data-name": "Path 10420",
    d: "M151.509,32.659a6.107,6.107,0,0,1-1.992,4.511,7.041,7.041,0,0,1-5.036,2.064,7.236,7.236,0,0,1-4.945-1.7,5.718,5.718,0,0,1-2.1-4.546,6.181,6.181,0,0,1,1.992-4.546,6.926,6.926,0,0,1,5.036-2.048,7.321,7.321,0,0,1,4.927,1.7A5.68,5.68,0,0,1,151.509,32.659Zm-2.335.234a6.053,6.053,0,0,0-1.811-4.074,4.157,4.157,0,0,0-2.9-1.4,4.326,4.326,0,0,0-3.768,1.848,5.226,5.226,0,0,0-.959,3.459,6.15,6.15,0,0,0,1.811,4.112,4.1,4.1,0,0,0,2.916,1.414,4.371,4.371,0,0,0,3.8-1.9,5.325,5.325,0,0,0,.905-3.459Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10421",
    "data-name": "Path 10421",
    d: "M164.207,26.428a3.538,3.538,0,0,0-.234,1.339v11.72h-.562l-9.038-9.872v8.17a3.538,3.538,0,0,0,.234,1.339H153.23a3.538,3.538,0,0,0,.234-1.339v-11.7h.525l9.076,9.853v-8.17a3.59,3.59,0,0,0-.234-1.339Z",
    fill: "#7c7f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10422",
    "data-name": "Path 10422",
    d: "M175,35.541a3.259,3.259,0,0,1-2.173,3.134,5.791,5.791,0,0,1-2.9.6,11.707,11.707,0,0,1-1.358-.144,9.427,9.427,0,0,1-2.916-1.2l-.272-2.064a12.591,12.591,0,0,0,1.43,1.268,5.94,5.94,0,0,0,3.169,1.339,2.9,2.9,0,0,0,1.686-.453,2.12,2.12,0,0,0,1.033-1.467,2.838,2.838,0,0,0,.053-.543,1.934,1.934,0,0,0-.652-1.449,9.879,9.879,0,0,0-2.154-1.377,21.936,21.936,0,0,1-2.863-1.648,2.764,2.764,0,0,1-1.286-2.192,2.27,2.27,0,0,1,.037-.415,2.72,2.72,0,0,1,1.286-1.776,5.411,5.411,0,0,1,3.025-.905,8.572,8.572,0,0,1,3.912.977l.2,1.686a5.706,5.706,0,0,0-3.859-1.867,2.892,2.892,0,0,0-.471.037q-1.845.364-1.848,1.611,0,1.322,2.644,2.591a15.839,15.839,0,0,1,3.025,1.758,3.2,3.2,0,0,1,1.249,2.5Z",
    fill: "#7c7f82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15921",
    "data-name": "Group 15921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10423",
    "data-name": "Path 10423",
    d: "M95.5,0a10.934,10.934,0,1,0,10.934,10.934A10.933,10.933,0,0,0,95.5,0Zm0,18.953a8.016,8.016,0,1,1,8.016-8.016A8.015,8.015,0,0,1,95.5,18.953Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15920",
    "data-name": "Group 15920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10424",
    "data-name": "Path 10424",
    d: "M90.393,7.675A8.008,8.008,0,0,1,94.43,4.389a6.636,6.636,0,0,0-5.56,6.546,6.721,6.721,0,0,0,.245,1.79,8.012,8.012,0,0,1,1.278-5.046Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10425",
    "data-name": "Path 10425",
    d: "M101.892,9.145a8.024,8.024,0,0,1-1.278,5.049,8.008,8.008,0,0,1-4.037,3.286,6.636,6.636,0,0,0,5.56-6.546,6.72,6.72,0,0,0-.245-1.79Z",
    fill: "url(#linear-gradient-2)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10426",
    "data-name": "Path 10426",
    d: "M28.02,31.49V29.922H4.948l3.228-5.507L0,35.232H28.02V33.719H2.722l1.3-2.229Z",
    fill: "#003b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10427",
    "data-name": "Path 10427",
    d: "M166.939,9.715h-28.02v1.513h25.3l-1.3,2.229H138.919v1.571h23.075l-3.228,5.507Z",
    fill: "#003b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10428",
    "data-name": "Path 10428",
    d: "M97.264,39.208H93.28a6.962,6.962,0,0,0,.527-2.855V24.526a6.953,6.953,0,0,0-.527-2.855h3.984a6.962,6.962,0,0,0-.527,2.855V36.353A6.953,6.953,0,0,0,97.264,39.208Z",
    fill: "url(#linear-gradient-4)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGlucroft);
export default __webpack_public_path__ + "static/media/logo-glucroft.9d49cb86dd0c1c4fd76f3cdcb92a7a97.svg";
export { ForwardRef as ReactComponent };